module.exports = __webpack_public_path__ + "static/media/guilt-large@3x.8d2a5760.png";